import { render, staticRenderFns } from "./source_list.vue?vue&type=template&id=20a0b5d5"
import script from "./source_list.vue?vue&type=script&lang=js"
export * from "./source_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports